import Fetcher from "../fetcher";
import getInitData from "../init/chargedata";
import SearchParams from "../init/searchparams";
import { isPlainObject, withProperties } from "../utils";
import { DEFAULT_POST_INIT, isJsonResponse } from "../fetcher/utils";

const $fetcher = Fetcher.many.init(DEFAULT_POST_INIT);
const $endpoint = new URL(process.env.EVENT_LOG_URL);

let $payload;

function __getEventPayload__(event) {
  return Promise.resolve(
    $payload ||
    getInitData().then($data => {
      const id = $data['modalauditid'];

      $payload = withProperties(Object.create(null), {
        actor: SearchParams.get('customer_email'),
        context: /Mobi/.test(navigator.userAgent) ? 'mobile' : 'web',
        label: id,
        modalauditid: id,
        token: process.env.EVENT_LOG_TOKEN
      });

      return $payload;
    })
  ).then($payload => JSON.stringify({
    ...(isPlainObject(event) ? event : {}),
    ...$payload,
    date: Date.now()
  }));
}

export default function __log__(event) {
  return __getEventPayload__(event)
    .then(body => {
      let attempts = 0;
      let timelapse = 0;
      const maxAttempts = 10;

      return (function __log__() {
        return (attempts < maxAttempts) && setTimeout(() => {
          return $fetcher($endpoint, { body })
            .then(response => (isJsonResponse(response) && response.ok || Promise.reject()))
            .catch(__log__);
        }, (timelapse += attempts++) * 1000);
      })();
    });
}
